<template>
  <div class="teslaCalculatorWrap">
    <div class="teslaCalculator">
      <div class="result"><input ref="input" type="text" class="show" value="0" /></div>
      <button class="cancle" @click="btnClick('ac')" data-Type="ac">C</button>
      <button class="number" @click="btnClick('', '7')">7</button>
      <button class="number" @click="btnClick('', '8')">8</button>
      <button class="number" @click="btnClick('', '9')">9</button>
      <button class="operation" @click="btnClick('operator', '+')" data-Type="operator">+</button>
      <button class="number" @click="btnClick('', '4')">4</button>
      <button class="number" @click="btnClick('', '5')">5</button>
      <button class="number" @click="btnClick('', '6')">6</button>
      <button class="operation" @click="btnClick('operator', '-')" data-Type="operator">-</button>
      <button class="number" @click="btnClick('', '1')">1</button>
      <button class="number" @click="btnClick('', '2')">2</button>
      <button class="number" @click="btnClick('', '3')">3</button>
      <button class="operation" @click="btnClick('operator', '*')" data-Type="operator">*</button>
      <button class="zero number" @click="btnClick('', '0+')">0</button>
      <button class="operation" @click="btnClick('equals')" data-Type="equals">=</button>
      <button class="operation" @click="btnClick('operator', '/')" data-Type="operator">/</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'calulator',
  data() {
    return {
      result : "",
      operCheck : false,
      numberCheck : true,
      equlasCheck : true
    }
  },
  methods: {
    btnClick(dataset, text){
      switch (dataset) {
        case "operator":
          const oper = text;
          this.operator(oper);
          break;
        case "ac":
          this.clear();
        break;
        case "equals":
          this.calc();
        break;
        default:
          const number = text;
          this.displayNumber(number);
        break;
      }
    },
    displayNumber(number) {
      this.operCheck = true;
      const current = this.$refs.input.value;

      //계산 끝난 후 초기화
      if (this.equlasCheck) {
        //연산자 눌렸을 시 계산기 값만 초기화
        if (this.numberCheck) {
          this.$refs.input.value = current === "0" ? number : this.$refs.input.value + number;
        } else {
          this.$refs.input.value = number;
          this.numberCheck = true;
        }
        this.result += number;
      } else {
        this.equlasCheck = true;
        this.$refs.input.value = number;
        this.result = number;
      }
    },
    calc() {
      // 지속적으로 계산기 값 누르는 거 확인
      if (this.$refs.input.value === "0") {
        this.clear();
      } else {
        //마지막이 연산자로 끝나는 지 확인
        if (!this.operCheck) {
          alert("Calculation is unavailable because of operation.");
        } else {
          // 계속 눌렸을 때 변경
          if (this.equlasCheck) {
            const final = eval(this.result);
            this.$refs.input.value = final;
            this.result = "";
            this.equlasCheck = false;
            this.operCheck = false;
          } else {
            this.clear();
          }
        }
      }
    },
    operator(oper) {
      if (!this.operCheck) {
        alert("Operation Error.");
      } else {
        this.operCheck = false;
        this.result += oper;
        this.numberCheck = false;
      }
    },
    clear() {
      this.$refs.input.value = 0;
      this.result = "";
      this.operCheck = false;
      this.equlasCheck = true;
    }
  },
}
</script>

<style scoped>
  .teslaCalculatorWrap {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    bottom: 0px;
    box-sizing: border-box;
  }

  .teslaCalculator {
    position: absolute;
    width: 100%;
    height: 100%;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: auto;
    overflow: hidden;
  }



  .teslaCalculator input,
  .teslaCalculator button {
    outline: none;
    color: #FFFFFF;
  }

  .teslaCalculator input {
    width: 100% !important;
    text-align: right;
    background: #5B5B5D;
    padding-right: 1rem;
    font-size: 4rem;
    grid-column: 1/5;
    box-sizing: border-box;
    border: none;
    height: 100%;
  }

  .teslaCalculator button {
    font-size: 3rem;
    font-weight: 400;
    border: none;
    color: #333333;
    background: #dfdfdf;
  }

  .teslaCalculator button:hover {
    filter: brightness(1.1);
  }

  .teslaCalculator button:active {
    filter: brightness(0.9);
  }

  .teslaCalculator .result {
    grid-column: 1/4;
    margin: 3px;
  }

  .teslaCalculator .zero {
    grid-column: 1/3;
  }

  .teslaCalculator .number {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3px;
  }

  .teslaCalculator .operation {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: orange;
    margin: 3px;
  }

  .teslaCalculator .cancle {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: gray;
    margin: 3px;
  }
</style>




// WEBPACK FOOTER //
// src/pages/Calculator/index.vue